// src/lib/analytics/ga-config.ts
/**
 * @fileoverview GA4 load gating — shared by the server layout (which renders the
 * Consent Mode bootstrap in <head>) and the client `GoogleAnalytics` component
 * (which loads the gtag.js library). Kept dependency-free and server-safe:
 * `NEXT_PUBLIC_*` env vars are inlined at build time for both runtimes.
 */

/** GA4 Measurement ID (`G-XXXXXXX`), or "" when unconfigured. */
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? ""

/** Whether GA4 DebugView mode is requested. */
export function isGaDebug(): boolean {
  return process.env.NEXT_PUBLIC_GA_DEBUG === "true"
}

/**
 * Whether Google Analytics should load at all. GA loads only in production (or
 * when `NEXT_PUBLIC_GA_DEBUG=true`), only when a Measurement ID is configured,
 * and never when explicitly disabled for CI perf runs. `CI` is intentionally
 * NOT consulted — it isn't inlined into the client bundle.
 */
export function shouldLoadGoogleAnalytics(): boolean {
  const environmentEnabled = process.env.NODE_ENV === "production" || isGaDebug()
  const skipForCiPerf = process.env.NEXT_PUBLIC_DISABLE_GA_IN_CI === "true"
  return environmentEnabled && Boolean(GA_MEASUREMENT_ID) && !skipForCiPerf
}
